<script setup lang="ts">
import Alert from '~/component/Alert.vue'
</script>
<template>
  <slot></slot>
  <Alert />
</template>
<style>
@import '@/assets/css/style.css';
</style>
